<div id="int-gallery-main" class="w-full h-full">
  <app-internal-toolbar [title]="'internal.gallery.title' | translate"> </app-internal-toolbar>

  <div class="flex flex-row w-full">
    <div id="int-gallery-list" class="w-1/5" [class.hide]="selectedCategory() != undefined">
      <div id="maintitle" class="text-xl font-bold text-center mb-8">
        {{ 'gallery.categories' | translate }}
      </div>

      <p-iconfield class="m-4">
        <p-inputicon>
          <mat-icon>search</mat-icon>
        </p-inputicon>
        <input
          class="w-full"
          #searchInput
          type="text"
          pInputText
          [placeholder]="'general.searchPlaceholder' | translate"
          (keyup)="searchFilter.set($event.target.value)"
          (keydown.enter)="searchInput.blur()"
        />
        @if (searchInput.value) {
          <p-inputicon
            class="cursor-pointer"
            (click)="searchInput.value = ''; searchFilter.set('')"
          >
            <mat-icon>close</mat-icon>
          </p-inputicon>
        }
      </p-iconfield>

      <button
        pButton
        [pt]="{ root: { style: { width: 'calc(100% - 32px)' } } }"
        class="m-4 mb-8 mt-0"
        [label]="'internal.gallery.newCategory' | translate"
        [outlined]="true"
        (click)="createCategory()"
      >
        <mat-icon>add</mat-icon>
      </button>

      <div class="category-list">
        @for (category of filteredCategories(); track category) {
          <div class="m-2 border-l-2 border-l-white flex flex-row">
            <div class="ml-4 mr-auto flex flex-col flex-1">
              <div class="text-xl mt-auto h-7">
                @if (loadingCategories()) {
                  <p-skeleton width="4rem" height="1.5rem" />
                } @else {
                  {{ category.title }}
                }
              </div>
              <div
                class="text-sm text-neutral-400 mb-auto overflow-hidden whitespace-nowrap text-ellipsis h-5"
              >
                @if (loadingCategories()) {
                  <p-skeleton width="12rem" height="1rem" class="mt-1" />
                } @else {
                  {{ getEvent(category.eventid)?.name ?? '' }}
                }
              </div>
            </div>
            <p-button
              class="ml-auto"
              [rounded]="true"
              [text]="true"
              (onClick)="selectCategory(category)"
            >
              <mat-icon color="white">arrow_forward_ios</mat-icon>
            </p-button>
          </div>
        } @empty {
          <div class="text-xl text-neutral-500 text-center">
            {{ 'gallery.currentNoCategories' | translate }}
          </div>
        }
      </div>
    </div>

    <div class="v-spacer desktop"></div>

    <div
      id="gallery-category"
      class="w-4/5 pl-4 pr-4"
      [class.hide]="selectedCategory() == undefined"
    >
      @if (selectedCategory()) {
        <div id="gallery-category-header" class="text-3xl flex flex-row items-center mb-1">
          <p-button
            [rounded]="true"
            [text]="true"
            (onClick)="selectCategory(undefined)"
            class="mobile"
          >
            <mat-icon color="white">arrow_back</mat-icon>
          </p-button>

          <span class="mr-auto">{{ selectedCategory().title }}</span>

          <div class="flex justify-end gap-2">
            @if (api.hasPermission('delete_category')) {
              <!-- <p-button
                [label]="'general.delete' | translate"
                [disabled]="selectedCategory()._id === undefined"
                severity="danger"
                (onClick)="deleteCategory()"
              /> -->

              <reactive-button
                [label]="'general.delete' | translate"
                [disabled]="selectedCategory()._id === undefined"
                icon="delete"
                severity="danger"
                variant="outlined"
                (onClick)="deleteCategory()"
              ></reactive-button>
            }
<!--             <p-button
              [label]="'general.cancel' | translate"
              severity="secondary"
              (onClick)="cancelEdit()"
            />
            <p-button
              [label]="'general.save' | translate"
              [disabled]="
                !categoryForm.valid || !(imagesChanged() || selectedCategory()._id === undefined)
              "
              (onClick)="saveEdit()"
            /> -->

            <reactive-button
              [label]="'general.cancel' | translate"
              icon="close"
              severity="secondary"
              variant="outlined"
              (onClick)="cancelEdit()"
            ></reactive-button>

            <reactive-button
              [label]="'general.save' | translate"
              icon="save"
              [disabled]="
                !categoryForm.valid || !(imagesChanged() || selectedCategory()._id === undefined)
              "
              variant="outlined"
              (onClick)="saveEdit()"
            ></reactive-button>
          </div>
        </div>

        @if (loadingImages()) {
          <p-skeleton width="3.75rem" height="1.3125rem" />
        } @else {
          <span class="text-neutral-500">
            {{ 'gallery.amountImages' | translate: { amount: images().length } }}
          </span>
        }
        <p-fieldset class="mt-4" [legend]="'internal.gallery.editTitle' | translate">
          <p-fluid>
            <form [formGroup]="categoryForm" class="flex flex-col gap-4 mt-2">
              <p-togglebutton
                formControlName="isPublic"
                fluid
                [onLabel]="'internal.gallery.public' | translate"
                [offLabel]="'internal.gallery.notpublic' | translate"
                (onChange)="categoryFormTouched.set(true)"
              />

              <p-floatlabel variant="on">
                <input
                  pInputText
                  formControlName="title"
                  [invalid]="
                    categoryForm.controls.title.invalid && categoryForm.controls.title.touched
                  "
                  (onChange)="categoryFormTouched.set(true)"
                  autocomplete="off"
                />
                <label>{{ 'internal.gallery.imageTitle' | translate }}</label>
              </p-floatlabel>

              <p-floatlabel variant="on">
                <textarea
                  pTextarea
                  formControlName="description"
                  [invalid]="
                    categoryForm.controls.description.invalid &&
                    categoryForm.controls.description.touched
                  "
                  (input)="categoryFormTouched.set(true)"
                  rows="7"
                  cols="30"
                  style="resize: none"
                  class="h-full"
                ></textarea>
                <label>{{ 'internal.gallery.description' | translate }}</label>
              </p-floatlabel>

              @if (loadingEvents()) {
                <p-skeleton height="2.625rem" />
              } @else {
                <p-floatlabel variant="on">
                  <p-autocomplete
                    [formControl]="eventControl"
                    [suggestions]="filteredEvents()"
                    (completeMethod)="_searchEvent($event)"
                    [lazy]="true"
                    [completeOnFocus]="true"
                    dataKey="_id"
                    optionLabel="name"
                    (onChange)="categoryFormTouched.set(true)"
                  />
                  <label>{{ 'internal.gallery.event' | translate }}</label>
                </p-floatlabel>
              }
            </form>
          </p-fluid>
        </p-fieldset>

        <p-fieldset class="mt-4" [legend]="'gallery.imagesTitle' | translate">
          @if (loadingImages()) {
            <p-skeleton height="19rem" />
          } @else {
            <div class="min-h-30 flex flex-col gap-8">
              <p-fileupload
                #fu
                class="pt-4"
                [customUpload]="true"
                [multiple]="true"
                maxFileSize="5000000"
                mode="advanced"
                [auto]="true"
                accept="image/*"
                [pt]="{ root: { class: 'border-0!' }, header: { class: 'hidden!' } }"
                (uploadHandler)="addNewImage($event)"
              >
                <ng-template
                  #content
                  let-files
                  let-uploadedFiles="uploadedFiles"
                  let-removeFileCallback="removeFileCallback"
                  let-removeUploadedFileCallback="removeUploadedFileCallback"
                >
                  <div
                    class="flex flex-col items-center gap-2 p-6 cursor-pointer border-2 border-dashed border-surface rounded-md"
                    (click)="fu.choose()"
                  >
                    <mat-icon [size]="32" class="text-muted-color">cloud_upload</mat-icon>
                    <div class="text-sm font-medium">
                      {{ 'internal.gallery.uploadText' | translate }}
                    </div>
                    <div class="text-xs text-muted-color">
                      {{ 'internal.gallery.uploadTextSize' | translate }}
                    </div>
                  </div>
                </ng-template>
              </p-fileupload>

              <div class="h-spacer"></div>

              @for (image of images(); track image.localID; let last = $last) {
                <div class="image-flex flex flex-row gap-4">
                  <div class="image">
                    <img
                      [src]="getImageThumbLink(image) | useHttpImgSrc"
                      class="w-80 m-auto"
                      [class.invisible]="image.imageLoading"
                      [style.max-width]="image.imageLoading ? 0 : undefined"
                      (load)="setImageLoading(image, false)"
                    />
                    @if (image.imageLoading) {
                      <p-skeleton width="20rem" height="14.375rem" />
                    } @else {
                      <div class="image-overlay noselect" (click)="clickReupload(image)">
                        <mat-icon [size]="32">cloud_upload</mat-icon>
                        <span>{{ 'internal.gallery.reuploadHint' | translate }}</span>
                      </div>
                    }
                  </div>

                  <input
                    hidden
                    type="file"
                    accept=".jpg,.png,.jpeg"
                    [id]="'fileInput-' + image.localID"
                    (change)="reuploadImage(image, $event.target.files)"
                  />

                  <form class="contents" [formGroup]="image.form">
                    <p-fluid class="flex-1 flex flex-col gap-4">
                      <p-floatlabel variant="on">
                        <input
                          pInputText
                          formControlName="title"
                          [invalid]="
                            image.form.controls['title'].invalid &&
                            image.form.controls['title'].touched
                          "
                          (onChange)="imageFormTouched.set(true)"
                          autocomplete="off"
                        />
                        <label>{{ 'internal.gallery.imageTitle' | translate }}</label>
                      </p-floatlabel>

                      <p-floatlabel variant="on" class="flex-1">
                        <textarea
                          pTextarea
                          formControlName="description"
                          [invalid]="
                            image.form.controls['description'].invalid &&
                            image.form.controls['description'].touched
                          "
                          (input)="imageFormTouched.set(true)"
                          cols="30"
                          style="resize: none"
                          class="h-full"
                        ></textarea>
                        <label>{{ 'internal.gallery.description' | translate }}</label>
                      </p-floatlabel>
                    </p-fluid>

                    <p-fluid class="image-button-grid w-52 flex flex-col gap-2">
                      <p-togglebutton
                        formControlName="isPublic"
                        fluid
                        [onLabel]="'internal.gallery.public' | translate"
                        [offLabel]="'internal.gallery.notpublic' | translate"
                        (onChange)="imageFormTouched.set(true)"
                      />

                      <p-togglebutton
                        formControlName="watermark"
                        fluid
                        [onLabel]="'internal.gallery.watermark' | translate"
                        [offLabel]="'internal.gallery.nowatermark' | translate"
                        (onChange)="imageFormTouched.set(true)"
                      />

                      @if (api.hasPermission('delete_image')) {
                        <p-button
                          class="mt-auto"
                          severity="danger"
                          [label]="'general.delete' | translate"
                          (onClick)="removeImage(image)"
                        />
                      }
                    </p-fluid>
                  </form>
                </div>

                @if (!last) {
                  <div class="h-spacer"></div>
                }
              } @empty {
                <div class="w-full text-center text-xl text-neutral-500 font-bold mt-10 mb-10">
                  {{ 'internal.gallery.noImages' | translate }}
                </div>
              }
            </div>
          }
        </p-fieldset>
      } @else {
        <div class="w-full text-center text-2xl text-neutral-500 font-bold mt-20">
          {{ 'internal.gallery.noCategorySelected' | translate }}
        </div>
      }
    </div>
  </div>
</div>
